import { BoxProps } from "@mantine/core";

import { fontSizes } from "#app/theme/v1/fontSizes";
import { Text } from "#shared/view/components/Text";
import { formatDate, QuoteRequestLine } from "shared";

export const QuotedAt = ({
  quoteRequestLine,
  ...props
}: {
  quoteRequestLine: QuoteRequestLine;
} & BoxProps) => {
  const quotedAt = quoteRequestLine.quotedAt
    ? formatDate(new Date(quoteRequestLine.quotedAt))
    : null;

  return (
    <Text fz={fontSizes.small} {...props}>
      {quotedAt}
    </Text>
  );
};
